export enum LocaleId {
  EnUS = 'en-US',
  Fi = 'fi',
}
